import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import { toast } from 'react-toastify';
import * as req from '../../../../axios/request/SocietyPortal/JournalReqs/JournalReqs'


function* getJournals(action) {
    try {
        const result = yield call(req.getJournalsReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_JOURNALS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_JOURNALS_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch journal entries");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_JOURNALS_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* getJournalDetails(action) {
    try {
        const result = yield call(req.getJournalDetailsReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_JOURNAL_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_JOURNAL_DETAILS_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch journal details");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_JOURNAL_DETAILS_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* createJournal(action) {
    try {
        const result = yield call(req.createJournalReq, action);
        if (result.success === true) {
            toast.success(result.message || "Journal entry created successfully");
            yield put({ type: types.CREATE_JOURNAL_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.CREATE_JOURNAL_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to create journal entry");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CREATE_JOURNAL_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* updateJournal(action) {
    try {
        const result = yield call(req.updateJournalReq, action);
        if (result.success === true) {
            toast.success(result.message || "Journal entry updated successfully");
            yield put({ type: types.UPDATE_JOURNAL_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.UPDATE_JOURNAL_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to update journal entry");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.UPDATE_JOURNAL_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* deleteJournal(action) {
    try {
        const result = yield call(req.deleteJournalReq, action);
        if (result.success === true) {
            toast.success(result.message || "Journal entry deleted successfully");
            yield put({ type: types.DELETE_JOURNAL_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.DELETE_JOURNAL_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to delete journal entry");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.DELETE_JOURNAL_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}


function* getAccountHeads(action) {
    try {
        const result = yield call(req.getAccountHeadsReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_ACCOUNT_HEADS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_ACCOUNT_HEADS_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch account heads");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_ACCOUNT_HEADS_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}


function* getJournalAuditLogs(action) {
    try {
        const result = yield call(req.getJournalAuditLogsReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_JOURNAL_AUDIT_LOGS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_JOURNAL_AUDIT_LOGS_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch audit logs");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_JOURNAL_AUDIT_LOGS_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* bulkValidateJournals(action) {
    try {
        const result = yield call(req.bulkValidateJournalsReq, action);
        if (result.success === true) {
            yield put({ type: types.BULK_VALIDATE_JOURNALS_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.(result.data);
        } else {
            yield put({ type: types.BULK_VALIDATE_JOURNALS_FAILURE, message: result?.message });
            toast.error(result?.message || "Validation failed");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_VALIDATE_JOURNALS_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* bulkUploadJournals(action) {
    try {
        const result = yield call(req.bulkUploadJournalsReq, action);
        if (result.success === true) {
            yield put({ type: types.BULK_UPLOAD_JOURNALS_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.(result.data);
            if (result.data?.errorCount === 0) {
                toast.success(result.message || "Journals imported successfully");
            } else {
                toast.warn(result.message || "Import completed with errors");
            }
        } else {
            yield put({ type: types.BULK_UPLOAD_JOURNALS_FAILURE, message: result?.message });
            toast.error(result?.message || "Import failed");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_UPLOAD_JOURNALS_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}


function* getChartOfAccountsDropdown(action) {
    try {
        const result = yield call(req.getChartOfAccountsDropdownReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_CHART_OF_ACCOUNTS_DROPDOWN_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_CHART_OF_ACCOUNTS_DROPDOWN_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch accounts");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_CHART_OF_ACCOUNTS_DROPDOWN_FAILURE, message: e?.message });
        toast.error(e?.response?.data?.message || "Something went wrong");
    }
}

export default function* JournalSaga() {
    yield takeLatest(types.GET_JOURNALS, getJournals);
    yield takeLatest(types.GET_JOURNAL_DETAILS, getJournalDetails);
    yield takeLatest(types.CREATE_JOURNAL, createJournal);
    yield takeLatest(types.UPDATE_JOURNAL, updateJournal);
    yield takeLatest(types.DELETE_JOURNAL, deleteJournal);
    yield takeLatest(types.GET_ACCOUNT_HEADS, getAccountHeads);
    yield takeLatest(types.GET_JOURNAL_AUDIT_LOGS, getJournalAuditLogs);
    yield takeLatest(types.BULK_VALIDATE_JOURNALS, bulkValidateJournals);
    yield takeLatest(types.BULK_UPLOAD_JOURNALS, bulkUploadJournals);
    yield takeLatest(types.GET_CHART_OF_ACCOUNTS_DROPDOWN, getChartOfAccountsDropdown);
}
